export default __webpack_public_path__ + "static/cafe_36050-2ec28dec7d40482842d5cc41cb536f22.png";